import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PlanGuard } from '@/components/guards';
import { BUILDER_PLAN_SLUG } from '@/services/auth/plan-slugs';

function CollectionsLayoutRoute() {
  return (
    <PlanGuard excludedPlans={[BUILDER_PLAN_SLUG]}>
      <Outlet />
    </PlanGuard>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections')({
  component: CollectionsLayoutRoute,
});
